export enum EYmPageScreen {
	OFFER_SCREEN = 'offer_screen',
	BRAND_SCREEN = 'brand_screen',
	CATALOG_SCREEN = 'catalog_screen',
	CHANNEL_DETAIL_SCREEN = 'channel_detail_screen',
	CREATE_POST_SCREEN = 'create_post_screen',
	FINANCE_SCREEN = 'finance_screen',
	FIRST_SCREEN = 'first_screen',
	MAIN_SCREEN = 'main_screen',
	MENU_TAB = 'menu_tab',
	MENU_TAB_MORE = 'menu_tab_more',
	POPUP = 'popup',
	STATISTICS_SCREEN = 'statistics_screen',
	YOUR_CHANNELS_SCREEN = 'your_channels_screen',
}
